import { default as aboutWcXp9EFnR8Meta } from "/var/jenkins_home/workspace/qboson-web/app/pages/about.vue?macro=true";
import { default as AIWbtYwqws5oMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/AI.vue?macro=true";
import { default as biopharmaceuticalR1eBV4JjspMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/biopharmaceutical.vue?macro=true";
import { default as blankHbxK5lu2sYMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/blank.vue?macro=true";
import { default as city7xXOplh06ZMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/city.vue?macro=true";
import { default as componentsa0LJlVyevLMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/docs/components.vue?macro=true";
import { default as indexKNWAcRqwiCMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/index.vue?macro=true";
import { default as _91id_93PdRSg8apIBMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/news-v2/[id].vue?macro=true";
import { default as index9MPUP6mJEcMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/news-v2/index.vue?macro=true";
import { default as newsujC91s5Vn3Meta } from "/var/jenkins_home/workspace/qboson-web/app/pages/news.vue?macro=true";
import { default as _91slug_93kdl6GNVPEmMeta } from "/var/jenkins_home/workspace/qboson-web/pages/post/[slug].vue?macro=true";
import { default as indexMaSRZu5anRMeta } from "/var/jenkins_home/workspace/qboson-web/pages/post/index.vue?macro=true";
import { default as indexf0cOY0GNfnMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/product/index.vue?macro=true";
import { default as product1000_45shanhaiO1zQtcIyLpMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/product/product1000-shanhai.vue?macro=true";
import { default as product1000bit4EnA4ezD7YMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/product/product1000bit.vue?macro=true";
import { default as productConsultationmb4PPmGarlMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/product/productConsultation.vue?macro=true";
import { default as productSpecshot8czXTFpMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/product/productSpecs.vue?macro=true";
import { default as setting4ZYwjlB2twMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/setting.vue?macro=true";
import { default as testXMbz2xyj0kMeta } from "/var/jenkins_home/workspace/qboson-web/app/pages/test.vue?macro=true";
export default [
  {
    name: aboutWcXp9EFnR8Meta?.name ?? "about",
    path: aboutWcXp9EFnR8Meta?.path ?? "/about",
    meta: aboutWcXp9EFnR8Meta || {},
    alias: aboutWcXp9EFnR8Meta?.alias || [],
    redirect: aboutWcXp9EFnR8Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/about.vue").then(m => m.default || m)
  },
  {
    name: AIWbtYwqws5oMeta?.name ?? "AI",
    path: AIWbtYwqws5oMeta?.path ?? "/AI",
    meta: AIWbtYwqws5oMeta || {},
    alias: AIWbtYwqws5oMeta?.alias || [],
    redirect: AIWbtYwqws5oMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/AI.vue").then(m => m.default || m)
  },
  {
    name: biopharmaceuticalR1eBV4JjspMeta?.name ?? "biopharmaceutical",
    path: biopharmaceuticalR1eBV4JjspMeta?.path ?? "/biopharmaceutical",
    meta: biopharmaceuticalR1eBV4JjspMeta || {},
    alias: biopharmaceuticalR1eBV4JjspMeta?.alias || [],
    redirect: biopharmaceuticalR1eBV4JjspMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/biopharmaceutical.vue").then(m => m.default || m)
  },
  {
    name: blankHbxK5lu2sYMeta?.name ?? "blank",
    path: blankHbxK5lu2sYMeta?.path ?? "/blank",
    meta: blankHbxK5lu2sYMeta || {},
    alias: blankHbxK5lu2sYMeta?.alias || [],
    redirect: blankHbxK5lu2sYMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/blank.vue").then(m => m.default || m)
  },
  {
    name: city7xXOplh06ZMeta?.name ?? "city",
    path: city7xXOplh06ZMeta?.path ?? "/city",
    meta: city7xXOplh06ZMeta || {},
    alias: city7xXOplh06ZMeta?.alias || [],
    redirect: city7xXOplh06ZMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/city.vue").then(m => m.default || m)
  },
  {
    name: componentsa0LJlVyevLMeta?.name ?? "docs-components",
    path: componentsa0LJlVyevLMeta?.path ?? "/docs/components",
    meta: componentsa0LJlVyevLMeta || {},
    alias: componentsa0LJlVyevLMeta?.alias || [],
    redirect: componentsa0LJlVyevLMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/docs/components.vue").then(m => m.default || m)
  },
  {
    name: indexKNWAcRqwiCMeta?.name ?? "index",
    path: indexKNWAcRqwiCMeta?.path ?? "/",
    meta: indexKNWAcRqwiCMeta || {},
    alias: indexKNWAcRqwiCMeta?.alias || [],
    redirect: indexKNWAcRqwiCMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93PdRSg8apIBMeta?.name ?? "news-v2-id",
    path: _91id_93PdRSg8apIBMeta?.path ?? "/news-v2/:id()",
    meta: _91id_93PdRSg8apIBMeta || {},
    alias: _91id_93PdRSg8apIBMeta?.alias || [],
    redirect: _91id_93PdRSg8apIBMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/news-v2/[id].vue").then(m => m.default || m)
  },
  {
    name: index9MPUP6mJEcMeta?.name ?? "news-v2",
    path: index9MPUP6mJEcMeta?.path ?? "/news-v2",
    meta: index9MPUP6mJEcMeta || {},
    alias: index9MPUP6mJEcMeta?.alias || [],
    redirect: index9MPUP6mJEcMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/news-v2/index.vue").then(m => m.default || m)
  },
  {
    name: newsujC91s5Vn3Meta?.name ?? "news",
    path: newsujC91s5Vn3Meta?.path ?? "/news",
    meta: newsujC91s5Vn3Meta || {},
    alias: newsujC91s5Vn3Meta?.alias || [],
    redirect: newsujC91s5Vn3Meta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/news.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93kdl6GNVPEmMeta?.name ?? "post-slug",
    path: _91slug_93kdl6GNVPEmMeta?.path ?? "/post/:slug()",
    meta: _91slug_93kdl6GNVPEmMeta || {},
    alias: _91slug_93kdl6GNVPEmMeta?.alias || [],
    redirect: _91slug_93kdl6GNVPEmMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/pages/post/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexMaSRZu5anRMeta?.name ?? "post",
    path: indexMaSRZu5anRMeta?.path ?? "/post",
    meta: indexMaSRZu5anRMeta || {},
    alias: indexMaSRZu5anRMeta?.alias || [],
    redirect: indexMaSRZu5anRMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/pages/post/index.vue").then(m => m.default || m)
  },
  {
    name: indexf0cOY0GNfnMeta?.name ?? "product",
    path: indexf0cOY0GNfnMeta?.path ?? "/product",
    meta: indexf0cOY0GNfnMeta || {},
    alias: indexf0cOY0GNfnMeta?.alias || [],
    redirect: indexf0cOY0GNfnMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/product/index.vue").then(m => m.default || m)
  },
  {
    name: product1000_45shanhaiO1zQtcIyLpMeta?.name ?? "product-product1000-shanhai",
    path: product1000_45shanhaiO1zQtcIyLpMeta?.path ?? "/product/product1000-shanhai",
    meta: product1000_45shanhaiO1zQtcIyLpMeta || {},
    alias: product1000_45shanhaiO1zQtcIyLpMeta?.alias || [],
    redirect: product1000_45shanhaiO1zQtcIyLpMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/product/product1000-shanhai.vue").then(m => m.default || m)
  },
  {
    name: product1000bit4EnA4ezD7YMeta?.name ?? "product-product1000bit",
    path: product1000bit4EnA4ezD7YMeta?.path ?? "/product/product1000bit",
    meta: product1000bit4EnA4ezD7YMeta || {},
    alias: product1000bit4EnA4ezD7YMeta?.alias || [],
    redirect: product1000bit4EnA4ezD7YMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/product/product1000bit.vue").then(m => m.default || m)
  },
  {
    name: productConsultationmb4PPmGarlMeta?.name ?? "product-productConsultation",
    path: productConsultationmb4PPmGarlMeta?.path ?? "/product/productConsultation",
    meta: productConsultationmb4PPmGarlMeta || {},
    alias: productConsultationmb4PPmGarlMeta?.alias || [],
    redirect: productConsultationmb4PPmGarlMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/product/productConsultation.vue").then(m => m.default || m)
  },
  {
    name: productSpecshot8czXTFpMeta?.name ?? "product-productSpecs",
    path: productSpecshot8czXTFpMeta?.path ?? "/product/productSpecs",
    meta: productSpecshot8czXTFpMeta || {},
    alias: productSpecshot8czXTFpMeta?.alias || [],
    redirect: productSpecshot8czXTFpMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/product/productSpecs.vue").then(m => m.default || m)
  },
  {
    name: setting4ZYwjlB2twMeta?.name ?? "setting",
    path: setting4ZYwjlB2twMeta?.path ?? "/setting",
    meta: setting4ZYwjlB2twMeta || {},
    alias: setting4ZYwjlB2twMeta?.alias || [],
    redirect: setting4ZYwjlB2twMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/setting.vue").then(m => m.default || m)
  },
  {
    name: testXMbz2xyj0kMeta?.name ?? "test",
    path: testXMbz2xyj0kMeta?.path ?? "/test",
    meta: testXMbz2xyj0kMeta || {},
    alias: testXMbz2xyj0kMeta?.alias || [],
    redirect: testXMbz2xyj0kMeta?.redirect || undefined,
    component: () => import("/var/jenkins_home/workspace/qboson-web/app/pages/test.vue").then(m => m.default || m)
  }
]